<template>
    <section class="client-settings">
        <section class="client-settings__header">
            <h2 class="client-settings__header__title">{{ $t('com.file.contact-box.settings') }}</h2>
        </section>
        <ClientSettingsMenu />
        <BreadcrumbsComponent />

        <section class="client-settings__body">
            <router-view />
        </section>
    </section>
</template>
<script charset="utf-8">
import BreadcrumbsComponent from "@/components/BasicControls/BreadcrumbsComponent.vue"
import ClientSettingsMenu from "./Parts/ClientSettingsMenu.vue"

export default {
    name: "client-settings",
    components: {
        BreadcrumbsComponent,
        ClientSettingsMenu,
    },
    data() {
        return {
        }
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.client-settings {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    color: #00082c;

    &__header {
        margin: 49px 0 0 48px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        font-size: 28px;
        line-height: 128%;

        &__action {
            display: flex;
            flex-direction: row;
            column-gap: 20px;
        }

        &__title {}

        &__button {
            padding: 13.5px 33px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #d80418;
            border-radius: 4px;
            border: 0px;
            transition: all 0.2s ease-in-out;

            &:hover {
                background-color: #ad0313;
            }

            &--spacing {
                margin-right: 12px;
            }

            &--white {
                border: 1px solid #bbc2ce;
                background-color: white;


                &:hover {
                    background-color: #e8ebef;
                }
            }
        }

        &__text {
            color: white;
            font-weight: 500;
            font-size: 16px;
            line-height: 132%;
            margin-left: 8px;

            &--white {
                color: #00082c;
            }
        }
    }

    &__errors {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        &__item {
            display: flex;
            flex-direction: row;
            column-gap: 20px;
            padding: 20px;
            border: 1px solid red;
            background: rgba(255, 0, 0, 0.3);
            align-items: center;

            &__button {
                padding: 13.5px 33px;
                align-items: center;
                justify-content: center;
                background: #d80418;
                border-radius: 4px;
                border: 0px;
                transition: all 0.2s ease-in-out;
                cursor: pointer;

                &:hover {
                    background-color: #ad0313;
                }

                &__text {
                    color: white;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 132%;
                    margin-left: 8px;
                }

                &--small {
                    padding: 7px 16px;
                }

                &--white {
                    border: 1px solid #bbc2ce;
                    background-color: white;


                    &:hover {
                        background-color: #e8ebef;
                    }

                    .component__button__text {
                        color: #00082c;
                    }
                }
            }
        }
    }

    &__body {
        margin: 0 48px 0 48px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 20px;
        row-gap: 20px;
    }
}
</style>
